import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import ContentSidebar from "./ContentSidebarUser";

const ContentSidebarPanel = ({
  isMobile, onClose, items, selectedRecord,
  setSelectedRecord, setViewerSrc, setViewerExtra,
  setViewerType, onPlayVideo, onViewPDF,
  renderActionButton, onChange, onToggle,
  sidebarLoading,
}) => (
  <div
    className="flex flex-col shrink-0 border-l border-[#e2e8f0] overflow-hidden"
    style={{ width: "280px", backgroundColor: "#F9F9F9", height: "100%" }}
  >
    <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0 [&::-webkit-scrollbar]:w-[4px] [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-thumb]:rounded-[3px]">
      <ContentSidebar
        items={items}
        sidebarLoading={sidebarLoading}
        onPlayVideo={onPlayVideo}
        onViewPDF={onViewPDF}
        visible={true}
        setViewerSrc={setViewerSrc}
        setViewerExtra={setViewerExtra}
        setViewerType={setViewerType}
        setSelectedRecord={setSelectedRecord}
        selectedRecord={selectedRecord}
        renderActionButton={renderActionButton}
        onChange={onChange}
      />
    </div>
  </div>
);

export default ContentSidebarPanel;